(function ($) {
  
  'use strict';
  
  /**
   * -------------------------------
   * GENERAL - GLOBAL VARIABLES
   * -------------------------------
   */
  
  var $window = $(window),
      position = $window.scrollTop(),
      last_scroll_direction = '',
      win_height_padded = $window.height() * 1.1;   
  
  /**
   * -------------------------------
   * GENERAL - HELPER FUNCTIONS
   * -------------------------------
   */

  // Retourne "true" si la page actuelle est la page d'accueil
  function isHomePage() {
    var url = window.location.pathname;
    
    if(url == '/') {
      return true;
    } else {
      return false;
    }
  }

  // Retourne "true" si la page actuelle est la page "pageHandle"
  function isPage(pageHandle) {
    var url = window.location.href;
    
    if(url.indexOf(pageHandle) != -1) {
      return true;
    } else {
      return false;
    }
  }
  
  // Convertit une string en prix
  function convertToPriceFormat(amount) {
    var domain = window.location.hostname,        
        amout_without_trailing_zeros = amount,
        amout_with_trailing_zeros = amount,
        trailing_zeros = 0;
    
  	amount = amount / 100; // Met le bon format
    amout_without_trailing_zeros = amount.toFixed();
    amout_with_trailing_zeros = amount.toFixed(2);    
    trailing_zeros = amout_with_trailing_zeros - amout_without_trailing_zeros;
    
    if(trailing_zeros == 0) {
      amount = amout_without_trailing_zeros; // Retire les dÃ©cimales
    } else {
      amount = amout_with_trailing_zeros; // Ajoute les dÃ©cimales
    }
    amount = amount.replace('.', ','); // Remplace le point par la virgule
    
    switch (domain) {
      case 'liaderma.fr':
        amount += ' â‚¬';
        break;
      default:
        amount += 'â‚¬';
    }
    
    return amount;
  }
  
  // Retourne la direction du scroll vertical
  function getVerticalScrollDirection() {
    var scrolled = $window.scrollTop(),
        vertical_scroll_direction = '';
    
    if(scrolled > position) {
      vertical_scroll_direction = 'down';
    } else if(scrolled < position) {
      vertical_scroll_direction = 'up';
    } else if(last_scroll_direction == 'down') {
   	  vertical_scroll_direction = 'down';
    } else if(last_scroll_direction == 'up') {
   	  vertical_scroll_direction = 'up';
    } else {
      vertical_scroll_direction = 'down';
    }
    
    position = scrolled;
    last_scroll_direction = vertical_scroll_direction;
    return vertical_scroll_direction;
  }
  
  // Scroll en haut de la page
  function scrollToTop() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }
  
  // Scroll en haut de la popup
  function scrollToTopModal($this) {
    var modal = $this.closest('.modal').get(0);
	modal.scrollIntoView(true);
  }
  
  // Scroll sur une section donnÃ©e
  function scrollIntoView($this, section) {
    if(section.length) {      
      section[0].scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }
  
  // Fixe le cta
  function fixCta($this) {
  	$this.addClass('animated slide-in-up');
    $this.css('position', 'fixed');
    $('.footer').addClass('footer--fixed');
  }
  
  // DÃ©fixe le cta
  function unfixCta($this) {
    $this.removeClass('animated slide-in-up');
    $this.css('position', 'unset');
    $('.footer').removeClass('footer--fixed');
  }  

  /**
   * -------------------------------
   * GENERAL - MODAL
   * -------------------------------
   */

  // Le bouton "Afficher la fenÃªtre" ouvre le dialogue
  document.querySelectorAll('.modal-opener').forEach((element) => {
    element.addEventListener("click", (e) => {
      e.preventDefault();
      const target = e.currentTarget;
      const dialogId = target.getAttribute('aria-controls');
      const dialog = document.querySelector('#' + dialogId);
      dialog.showModal();
    });
  });
  
  // Le bouton "Fermer" ferme le dialogue
  document.querySelectorAll('.modal-closer').forEach((element) => {
    element.addEventListener("click", (e) => {
      const target = e.currentTarget;
      const dialog = target.closest('dialog');
      dialog.close();
    });
  });
  
  /**
   * -------------------------------
   * GENERAL - LOAD
   * -------------------------------
   */
  
  // Fixe les ctas
  function fixCtaOnLoad(e) {
    // Fixe les ctas fixes si on revient sur cette page sur une ancre basse
    var scrolled = $window.scrollTop(),
        cta_animated = $('.fix-cta-on-scroll.animated'),
        trigger = $('.trigger-sticky-form').eq(0);
    
    cta_animated.each(function() {
      var $this = $(this),
          offset_top = trigger.offset().top;
      
      if (scrolled > offset_top) {
        unfixCta($this);
      }
    });
  }
  
  // Fixe le cta de la page d'accueil au scroll
  function fixCtaOnScroll(e) {
    var scrolled = $window.scrollTop(),
        cta_animated = $('.fix-cta-on-scroll.animated'),
        cta_not_animated = $('.fix-cta-on-scroll:not(.animated)'),
        trigger = $('.trigger-sticky-form').eq(0);
    
    $(cta_not_animated).each(function () {
      var $this = $(this),
          offset_top = trigger.offset().top;

      if (scrolled > offset_top) {
        if ($this.data('timeout')) {
          window.setTimeout(function(){
            fixCta($this);
          }, parseInt($this.data('timeout'), 10));
        } else {
          fixCta($this);
        }
      }
    });
    
    $(cta_animated).each(function () {
        var $this = $(this),
            offset_top = trigger.offset().top;
      
        if (scrolled < offset_top) {
          unfixCta($this);
        }
    });
  }
  
  // DÃ©marre le carousel des slideshows
  function startSlideshowCarousels() {
    var slideshow_carousels = $('.image-with-text-carousel'),
        slides_to_show_scroll = 1,
        prev_arrow = '<svg class="icon icon--custom" xmlns="http://www.w3.org/2000/svg" width="14.618" height="23.231" viewBox="0 0 14.618 23.231"><path id="Path_4" data-name="Path 4" d="M0,0-11,9.82,0,19" transform="translate(12.5 2.118)" fill="none" stroke="#9FDAF3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="3"/></svg>',
        next_arrow = '<svg class="icon icon--custom" xmlns="http://www.w3.org/2000/svg" width="14.618" height="23.231" viewBox="0 0 14.618 23.231"><path id="Path_4" data-name="Path 4" d="M0,0,11,9.82,0,19" transform="translate(2.118 2.118)" fill="none" stroke="#9FDAF3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="3"/></svg>';

    slideshow_carousels.each(function() {
      var carousel = $(this),
          autoplay = carousel.data('auto-play'),
          arrows = carousel.data('arrows'),
          dots = carousel.data('dots');

      carousel.slick({
        autoplay: autoplay,
        autoplaySpeed: 20000,
        arrows: arrows,
        centerMode: false,
        dots: dots,
        draggable: true,
        infinite: false,
        slidesToShow: slides_to_show_scroll,
        slidesToScroll: 1,
        speed: 300,
        swipe: true,
        swipeToSlide: false,
        touchThreshold: 5,
        useCSS: false,
        useTransform: true,
        prevArrow: '<button class="slick-prev">' + prev_arrow + '</button>',
        nextArrow: '<button class="slick-next">' + next_arrow + '</button>',
        responsive: [
          {
            breakpoint: 500,
            settings: {
              dots: false
            }
          }
        ]
      });
    });
  }
  
  // DÃ©marre le carousel de section reassurance (sur la page panier)
  function startReassuranceCarousels() {
    var reassurance_carousels = $('.product-reassurance'),
        slides_to_show_scroll = 2;

    if(window.innerWidth < 500) {
      reassurance_carousels.each(function() {
        var reassurance_carousel = $(this),
            carousel = reassurance_carousel.find('.bullet-points');

        if(!carousel.hasClass('slick-initialized')) {
          carousel.slick({
            autoplay: true,
            arrows: false,
            centerMode: false,
            dots: true,
            draggable: true,
            infinite: true,
            slidesToShow: slides_to_show_scroll,
            slidesToScroll: slides_to_show_scroll,
            speed: 500,
            swipe: true,
            swipeToSlide: false,
            touchThreshold: 5,
            useCSS: false,
            useTransform: true
          });
        }
      });
    }
  }
  
  // DÃ©marre le carousel de la liste des produits addon (sur la page panier)
  function startAddonProductListCarouselsCartPage() {
    var product_list_carousels = $('.template-cart').find('.main').find('.cart-addon-products--carousel'),
        slides_to_show_scroll = 4,
        prev_arrow = '<svg class="icon icon--custom" xmlns="http://www.w3.org/2000/svg" width="14.618" height="23.231" viewBox="0 0 14.618 23.231"><path id="Path_4" data-name="Path 4" d="M0,0-11,9.82,0,19" transform="translate(12.5 2.118)" fill="none" stroke="#9FDAF3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="3"/></svg>',
        next_arrow = '<svg class="icon icon--custom" xmlns="http://www.w3.org/2000/svg" width="14.618" height="23.231" viewBox="0 0 14.618 23.231"><path id="Path_4" data-name="Path 4" d="M0,0,11,9.82,0,19" transform="translate(2.118 2.118)" fill="none" stroke="#9FDAF3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="3"/></svg>';

    if(window.innerWidth >= 500) {
      product_list_carousels.each(function() {
        var carousel = $(this);

        carousel.slick({
          autoplay: true,
          arrows: true,
          centerMode: false,
          dots: false,
          draggable: true,
          infinite: true,
          slidesToShow: slides_to_show_scroll,
          slidesToScroll: 1,
          speed: 500,
          swipe: true,
          swipeToSlide: false,
          touchThreshold: 5,
          useCSS: false,
          useTransform: true,
          prevArrow: '<button class="slick-prev">' + prev_arrow + '</button>',
          nextArrow: '<button class="slick-next">' + next_arrow + '</button>',
          responsive: [
            {
              breakpoint: 500,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 1025,
              settings: {
                slidesToShow: 3
              }
            }
          ]
        });
      });
    }
  }
  
  // DÃ©marre le carousel de la liste des produits
  function startProductListCarousels() {
    startAddonProductListCarouselsCartPage();
  }
  
  // DÃ©marre les carousels de reviews
  function startReviewsCarousels() {
    var reviews_carousels_wrappers = $('.carousel-reviews-wrapper'),
        slides_to_show_mobile = 1,
        slides_to_show_tablet = 2,
        slides_to_show_desktop = 3,
        prev_arrow = '<svg class="icon icon--custom" xmlns="http://www.w3.org/2000/svg" width="21.243" height="37.483" viewBox="0 0 21.243 37.483"><path id="Path_4" data-name="Path 4" d="M0,0-14,14.988,0,29" transform="translate(17 4.24)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="6"/></svg>',
        next_arrow = '<svg class="icon icon--custom" xmlns="http://www.w3.org/2000/svg" width="21.243" height="37.483" viewBox="0 0 21.243 37.483"><path id="Path_4" data-name="Path 4" d="M0,0,14,14.988,0,29" transform="translate(4.243 4.24)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="6"/></svg>';

    reviews_carousels_wrappers.each(function() {
      var reviews_carousels_wrapper = $(this),      
      	  reviews_carousels = reviews_carousels_wrapper.find('.carousel-reviews');
      
      reviews_carousels.each(function() {
        var carousel = $(this),
            activate = carousel.data('activate'),
            arrows = carousel.data('arrows'),
            initial_slide = parseInt(carousel.data('initial-slide'));

        if(activate) {
          carousel.slick({
            adaptiveHeight: false,
            autoplay: false,
            autoplaySpeed: 3000,
            arrows: arrows,
            centerMode: true,
            centerPadding: 0,
            dots: false,
            draggable: true,
            infinite: true,
            initialSlide: initial_slide,
            slidesToShow: slides_to_show_desktop,
            slidesToScroll: 1,
            speed: 3000,
            swipeToSlide: true,
            touchThreshold: 4,
            prevArrow: '<button class="slick-prev">' + prev_arrow + '</button>',
            nextArrow: '<button class="slick-next">' + next_arrow + '</button>',
            responsive: [
              {
                breakpoint: 1025,
                settings: {
                  centerMode: true,
                  slidesToShow: slides_to_show_tablet
                }
              },
              {
                breakpoint: 500,
                settings: {
                  centerMode: true,
                  slidesToShow: slides_to_show_mobile
                }
              }
            ]
          });
        }
      });
      
      // Fait passer la section prÃ©cÃ©dente au-dessus du carousel
      var current_shopify_section = reviews_carousels_wrapper.closest('.shopify-section'),
          previous_shopify_section = current_shopify_section.prev('.shopify-section');
      
      previous_shopify_section.css('z-index', '1');
    });
  }
  
  // DÃ©marre les carousels des sections de type "Texte + Carousel"
  function startTxtCrslSectionsCarousels() {
    var txt_crsl_sections = $('.text-with-carousel'),
        slides_to_scroll = 1,
        slides_to_show_1921 = 2,
        center_padding_desktop = '0',
        center_padding_361 = '20px',
        center_padding_500 = '20px',
        prev_arrow = '<svg class="icon icon--custom" xmlns="http://www.w3.org/2000/svg" width="21.243" height="37.483" viewBox="0 0 21.243 37.483"><path id="Path_4" data-name="Path 4" d="M0,0-14,14.988,0,29" transform="translate(17 4.24)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="6"/></svg>',
        next_arrow = '<svg class="icon icon--custom" xmlns="http://www.w3.org/2000/svg" width="21.243" height="37.483" viewBox="0 0 21.243 37.483"><path id="Path_4" data-name="Path 4" d="M0,0,14,14.988,0,29" transform="translate(4.243 4.24)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="6"/></svg>';

    txt_crsl_sections.each(function() {
      var txt_crsl_section = $(this),
          carousel = txt_crsl_section.find('.carousel'),
          activate = carousel.data('activate'),
          arrows = carousel.data('arrows'),
          slides_to_show_mobile = parseInt(carousel.data('items-mobile')),
          slides_to_show_desktop = parseInt(carousel.data('items-desktop'));

      if(txt_crsl_section.hasClass('carousel--remove-spaces-true')) {
        slides_to_show_desktop = slides_to_show_desktop;
      }
      
      if(carousel.hasClass('reviews--carousel')) {
        center_padding_361 = '60px';
        center_padding_500 = '80px';
      }

      if(activate) {
        carousel.slick({
          adaptiveHeight: false,
          autoplay: false,
          autoplaySpeed: 3000,
          arrows: arrows,
          centerMode: false,
          centerPadding: center_padding_desktop,
          dots: false,
          draggable: true,
          infinite: true,
          slidesToShow: slides_to_show_desktop,
          slidesToScroll: slides_to_scroll,
          touchThreshold: 4,
          prevArrow: '<button class="slick-prev">' + prev_arrow + '</button>',
          nextArrow: '<button class="slick-next">' + next_arrow + '</button>',
          responsive: [
            {
              breakpoint: 500,
              settings: {
                centerMode: false,
                centerPadding: center_padding_500,
                slidesToShow: slides_to_show_mobile
              }
            },
            {
              breakpoint: 361,
              settings: {
                centerMode: false,
                centerPadding: center_padding_361,
                slidesToShow: slides_to_show_mobile
              }
            }
          ]
        });
      }
    });
  }
  
  // DÃ©marre le carousel des questionnaires
  function startQuestionnaireCarousels() {
    var questionnaire_carousels = $('.questionnaire--carousel'),
        slides_to_show_scroll = 1,
        prev_arrow = '<svg class="icon icon--custom" xmlns="http://www.w3.org/2000/svg" width="14.618" height="23.231" viewBox="0 0 14.618 23.231"><path id="Path_4" data-name="Path 4" d="M0,0-11,9.82,0,19" transform="translate(12.5 2.118)" fill="none" stroke="#9FDAF3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="3"/></svg>',
        next_arrow = '<svg class="icon icon--custom" xmlns="http://www.w3.org/2000/svg" width="14.618" height="23.231" viewBox="0 0 14.618 23.231"><path id="Path_4" data-name="Path 4" d="M0,0,11,9.82,0,19" transform="translate(2.118 2.118)" fill="none" stroke="#9FDAF3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="3"/></svg>';

    questionnaire_carousels.each(function() {
      var carousel = $(this),
          activate = carousel.data('activate'),
          arrows = carousel.data('arrows');

      if(activate) {
        carousel.slick({
          autoplay: false,
          autoplaySpeed: 5000,
          arrows: arrows,
          centerMode: false,
          dots: false,
          draggable: false,
          infinite: false,
          slidesToShow: slides_to_show_scroll,
          slidesToScroll: 1,
          speed: 300,
          swipe: false,
          swipeToSlide: false,
          touchMove: false,
          touchThreshold: 5,
          useCSS: false,
          useTransform: true,
          prevArrow: '<button class="slick-prev">' + prev_arrow + '</button>',
          nextArrow: '<button class="slick-next">' + next_arrow + '</button>'
        });
      }
    });
  }
  
  // DÃ©marre les diffÃ©rents carousels
  function startCarousels(e) {
    startSlideshowCarousels();
    startProductListCarousels();    
    startTxtCrslSectionsCarousels();
    startReviewsCarousels();
    startQuestionnaireCarousels();
    startReassuranceCarousels();
  }
  
  // Affiche les rÃ©sultats du questionnaire sur la page de rÃ©sultats
  function displayQuestionnaireResults(e) {
    // On rÃ©cupÃ¨re les rÃ©ponses du questionnaire dans le navigateur en local
    var questionnaire_answers_key = '__questionnaire_answers',
    	questionnaire_answers_json = localStorage.getItem(questionnaire_answers_key),
        questionnaire_answers = JSON.parse(questionnaire_answers_json);
    
    //console.log('Questionnaire answers: ', questionnaire_answers);
    
    // Calcule et affiche l'IMC
    var weight_value = parseFloat(questionnaire_answers["q_poids"]),
        size_value = parseFloat(questionnaire_answers["q_taille"]),
        size_value_meter = size_value / 100,
        size_value_meter_square = size_value_meter * size_value_meter,
        imc_value = (weight_value / size_value_meter_square).toFixed(1),
        imc_size_value = $('.imc-size--value'),
        imc_weight_value = $('.imc-weight--value'),
        imc_value_value = $('.imc-value--value');
    
    imc_size_value.text(size_value);
    imc_weight_value.text(weight_value);
    imc_value_value.text(imc_value);
  }
  
  // Au load d'une page
  function _loadListener(e) {
    startCarousels(e);
    fixCtaOnLoad(e);
    fixCtaOnScroll(e);
    displayQuestionnaireResults(e);
  }
  
  // Au load d'une page
  $window.on('load', function(e) {
    _loadListener(e);
  });
  
  /**
   * -------------------------------
   * GENERAL - SCROLL
   * -------------------------------
   */

  // Starts the videos
  window.startVideos = function (e) {
    var scrolled = $window.scrollTop(),
        videos_wrappers = '';
    
    if(window.innerWidth < 500) {
      videos_wrappers = $('.video-wrapper--file.hidden-handheld-and-up');
    } else {
      videos_wrappers = $('.video-wrapper--file.hidden-thumb');
    }
    
    videos_wrappers = videos_wrappers.add('.video-wrapper--file.all');
    
    videos_wrappers.each(function() {
      var video_wrapper = $(this),
          video_tag = video_wrapper.find('[data-play-scroll="true"]');
      
      if(video_tag.length) {
      	var video = video_tag.get(0),
            video_button = video_wrapper.find('button'),
            off_set_top = video_tag.offset().top,
            video_height = video_tag.height();

        if(scrolled + win_height_padded > off_set_top && scrolled < off_set_top + video_height) {
          if(video.paused) {
            video_button.removeClass('active');
            video.play().catch(function(error) {
              video_button.addClass('active');
            }); 
            
            if(video_tag.attr('data-unmute-scroll') == "true") {
              video.muted = false;
            }
          }
        } else {
          if(!video.paused) {
            video.pause();
            video.muted = true;
          }
        }
      }
    });
  }
  
  // DÃ©marre les animations de la section "Reviews"
  function startReviewsAnimations() {
    var scrolled = $window.scrollTop(),
    	crsl_reviews_wrappers = $('.carousel-reviews-wrapper');
    
    crsl_reviews_wrappers.each(function() {
      var crsl_reviews_wrapper = $(this),
          carousel_reviews = crsl_reviews_wrapper.find('.carousel-reviews.slick-initialized'),
          offset_top = crsl_reviews_wrapper.offset().top;
      
      if (scrolled > offset_top) {
        carousel_reviews.each(function(i) {
          var carousel_review = $(this),
              rest = i % 2;

          if(rest != 0) {
            carousel_review.slick('slickPrev');
          } else {
            carousel_review.slick('slickNext');
          }
        });
      }
    });
  }
  
  // DÃ©marre les diffÃ©rentes animations
  function startAnimations(e) {
    startReviewsAnimations();
  }
  
  // Au scroll d'une page
  function _scrollListener(e) {
    //startVideos(e);
    startAnimations(e);
    fixCtaOnScroll(e);
  }
  
  // Au scroll d'une page
  $window.on('scroll', function(e) {
    _scrollListener(e);
  });
  
  /**
   * -------------------------------
   * GENERAL - ARROW ANCHOR
   * -------------------------------
   */
  
  // Affiche la section suivante
  function showNextSection($this, e) {
	var current_section = $this.closest('.shopify-section'),
        next_section = current_section.next('.shopify-section');
    
    scrollIntoView($this, next_section);
  }
  
  // Au clic sur une ancre flÃ¨che
  function _clickArrowAnchorListener($this, e) {
    showNextSection($this, e);
  }
  
  // Au clic sur une ancre flÃ¨che
  $(document).on('click', '.arrow-anchor--icon', function(e) {
    _clickArrowAnchorListener($(this), e);
  });
  
  /**
   * -------------------------------
   * GENERAL - READ MORE LINKS
   * -------------------------------
   */
  
  // Affiche tout le contenu texte associÃ©
  function showFullContent($this, e) {
  	var is_block = $this.data('block'),
        button_text = $this.find('.button--text');
    
    e.preventDefault();
    
    if(!is_block) {
      var section = $this.closest('.section'),
          content_full = section.find('.section__content-full').eq(0),
          content_bullet_points = section.find('.section__content-bullet-points').eq(0);
      
      content_full.slideToggle();
      content_bullet_points.slideToggle();
      $this.closest('.button-group').remove();
    } else {
      var section_wrapper = $this.closest('.section-wrapper'),
          content_full = section_wrapper.find('.section__content-full').eq(0);

      content_full.slideToggle();
    }
    
    // VÃ©rifie si on doit changer le texte du bouton    
    if(button_text.text() == '+') {
      button_text.text('-');
    } else if(button_text.text() == '-') {
      button_text.text('+');
    }
  }
  
  // Au clic sur un lien "read_more"
  function _clickReadMoreLinkListener($this, e) {
    showFullContent($this, e);
  }
  
  // Au clic sur un lien "read_more"
  $(document).on('click', 'a[href="#read_more"]', function(e) {
    _clickReadMoreLinkListener($(this), e);
  });
  
  /**
   * -------------------------------
   * SNIPPET - QUESTIONS
   * -------------------------------
   */
  
  // Affiche ou cache la rÃ©ponse d'une question
  function toggleAnswer($this) {
    var faq_item = $this.closest('.faq__item');
    
    if(faq_item.attr('aria-hidden') == 'true') {
    	faq_item.attr('aria-hidden', 'false');
    } else {
    	faq_item.attr('aria-hidden', 'true');
    }
    
    $this.next('.faq__answer').slideToggle(250);    
  }
  
  // Au clic sur une question
  function _clickQuestionListener($this) {
    toggleAnswer($this);
  }
  
  // Au clic sur une question
  $(document).on('click', '.faq__question', function(e) {
    _clickQuestionListener($(this));
  });

  /**
   * -------------------------------
   * SNIPPET - VIDEO
   * -------------------------------
   */
  
  // Starts or stops a video
  function playVideo(video, video_button, unmute_click, enlarge_click) {    
    if(video.paused) {
      video.play();
      video_button.removeClass('active');
    } else {
      if(unmute_click == 'false' && enlarge_click == 'false') {
        video.pause();
        video_button.addClass('active');
      }
    }
  }
  
  // Mutes or unmutes a video
  function unmuteVideo(video_wrapper, video, enlarge_click) {
    var section_snippet_inner = video_wrapper.closest('.section__snippet--inner');
    
    if(video.muted) {
      video.muted = false;
    } else {
      if(enlarge_click == 'false') {
        video.muted = true;
      } else if(section_snippet_inner.hasClass('larger')) {
        video.muted = true;
      }
    }
  }
  
  // Enlarges or shrinks a video
  function enlargeVideo(video_wrapper, video) {  
    var section_snippet_inner = video_wrapper.closest('.section__snippet--inner');
    
    if(!section_snippet_inner.hasClass('larger')) {
      section_snippet_inner.addClass('larger');

      if(window.innerWidth < 500) {
        if(video.requestFullscreen) {
          video.requestFullscreen();
        } else if(video.mozRequestFullScreen) {
          video.mozRequestFullScreen();
        } else if(video.webkitRequestFullscreen) {
          video.webkitRequestFullscreen();
        } else if(video.msRequestFullscreen) { 
          video.msRequestFullscreen();
        } else {
          video.webkitEnterFullscreen();
        }
      }
    } else {
      section_snippet_inner.removeClass('larger');
    }
  } 
  
  // Starts or stops / Mutes or unmutes / Enlarges or shrinks a video
  function handleVideo($this) {
    var video_wrapper = $this.closest('.video-wrapper'),
    	video_tag = video_wrapper.find('video'),
        video = video_tag.get(0),
        video_button = video_wrapper.find('button'),
        play_click = video_tag.attr('data-play-click'),
        unmute_click = video_tag.attr('data-unmute-click'),
        enlarge_click = video_tag.attr('data-enlarge-click');
    
    if(play_click == 'true') {
      playVideo(video, video_button, unmute_click, enlarge_click);
    }
    
    if(unmute_click == 'true') {
      unmuteVideo(video_wrapper, video, enlarge_click);
    }
    
    if(enlarge_click == 'true') {
      enlargeVideo(video_wrapper, video);
    }
  }
  
  // Exits full screen mode on a video
  function exitFullScreen() { 
    var fullscreen = $(document).get(0).fullscreen;

    if(!fullscreen) {
      $('video').each(function() {
        var video_tag = $(this);
        
        video_tag.closest('.section__snippet--inner').removeClass('larger');
        video_tag.get(0).muted = true;
      });
    }
  }
  
  // On clicking on a native video
  function _clickVideoFileListener($this, e) {
    handleVideo($this);
  }
  
  // When exiting full screen mode on a video
  function _exitVideoFullScreenListener() {
    exitFullScreen();
  }
  
  // On clicking on a native video
  $(document).on('click', '.video-file', function(e) {
    _clickVideoFileListener($(this), e);
  });
  
  // When exiting full screen mode on a video
  $(document).on('fullscreenchange webkitfullscreenchange mozfullscreenchange webkitendfullscreen', function() {
    _exitVideoFullScreenListener();
  });
  
  /**
   * -------------------------------
   * SECTION - COLLECTION TEMPLATE - Filters
   * -------------------------------
   */
  
  // Affiche ou cache les filtres
  function toggleFilters($this, e) {
    var filters = $this.closest('.collection-template-filters').find('.collection__filters');
    
    filters.toggleClass('hidden-portable');
  }
  
  // Affiche ou retire un filtre
  function toggleFilter($this, e) {
    var filter_option = $this.closest('.collection-filter-option'),
        filter_href = $this.attr('href'),
        url_split = window.location.pathname.split('/'),
        url_pathname = url_split.pop(),
        default_filter_href = url_split.join('/');
    
    if(filter_option.hasClass('selected')) {
      e.preventDefault();
      window.location.href = default_filter_href;
    } else {
      window.location.href = filter_href; 
    }        
  }
  
  // Au clic sur le bouton pour ouvrir ou fermer les filtres
  function _clickToggleFiltersListener($this, e) {
    toggleFilters($this, e);
  }
  
  // Au clic sur un filtre de collection
  function _clickCollectionFilterListener($this, e) {
    toggleFilter($this, e);
  }
  
  // Au clic sur le bouton pour ouvrir ou fermer les filtres
  $(document).on('click', '[data-action="toggle-filters"]', function(e) {
    _clickToggleFiltersListener($(this), e);
  });
  
  // Au clic sur un filtre de collection
  $(document).on('click', '.filter-option-link', function(e) {
    _clickCollectionFilterListener($(this), e);
  });
  
  /**
   * -------------------------------
   * SECTION - META FORM - Ajout au panier
   * -------------------------------
   */
  
  // Ajoute une variante Ã  la file d'attente
  function addVariantToQueue(variant_id, variant_quantity, variant_properties){
    if(variant_properties == '') {
      variant_properties = new Object();
    }
    
    Shopify.queue.push({
      variantId: variant_id,
      quantity: variant_quantity,
      properties: variant_properties
    });
  }
  
  // Pousse la file d'attente au panier
  Shopify.moveAlong = function() {
    // Si nous avons encore des demandes dans la file d'attente, traitons la prochaine
    if (Shopify.queue.length) {
      var request = Shopify.queue.shift(),
          data = {};

      if(request.properties) {
        data = {
          id: request.variantId,
          quantity: request.quantity,
          properties: request.properties
        };
      }
      else {
        data = {
          id: request.variantId,
          quantity: request.quantity
        };
      }

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: data,
        success: function(response) {
          if (Shopify.queue.length){
            Shopify.moveAlong();
          } else {
            if(isPage('/cart')) {
               // On rafraichit la page panier
               location.reload();
            } else {
               // On lance un Ã©vÃ©nement pour que le mini-panier puisse effectuer des traitements supplÃ©mentaires, comme le rÃ©affichage du mini-panier.
               $(document).trigger('product.added');
          	}
          } 
        },
        error: function(response) {
          alert(response.responseJSON.description); // Afficher les erreurs dans la boÃ®te de dialogue

          // Si ce n'est pas le dernier, on rappelle la fonction Move Along
          if (Shopify.queue.length){
            Shopify.moveAlong();
          }
        }
      });
    } else {
      // On lance un Ã©vÃ©nement pour que le mini-panier puisse effectuer des traitements supplÃ©mentaires, comme le rÃ©affichage du mini-panier.
      $(document).trigger('product.added');
    }
  };
  
  // Ajoute une variante au panier
  function addVariantToCart(variant_id, variant_quantity, variant_properties) {
    // DÃ©finit la file d'attente vide
    Shopify.queue = [];
    
    // Ajoute les snacks dans la file d'attente
    addVariantToQueue(variant_id, variant_quantity, variant_properties);
    
    // Pousse la file d'attente au panier
    Shopify.moveAlong();
  }
  
  // Ajoute un produit au panier
  function addToCartAjax($this, e) {
    var variant_id = $this.data('variant-id'),
    	variant_quantity = 1,
    	variant_properties = '',
        custom_quantity = parseInt($this.closest('.product-form').find('.product-quantity-value').text());
    
    if(custom_quantity) {
      variant_quantity = custom_quantity;
    }
    
    e.preventDefault();
    addVariantToCart(variant_id, variant_quantity, variant_properties);
  }
  
  // Au clic sur un bouton d'ajout au panier
  function _clickAddToCartAjaxListener($this, e) {
    addToCartAjax($this, e);
  }
  
  // Au clic sur un bouton d'ajout au panier
  $(document).on('click', '[data-action="add-to-cart-ajax"]', function(e) {
    _clickAddToCartAjaxListener($(this), e);
  });
  
  /**
   * -------------------------------
   * SECTION - META FORM - Product
   * -------------------------------
   */
  
  // Ajoute 1 Ã  la quantitÃ© de l'item
  function addQuantity($this) {
    var quantity_item = $this.siblings('.quantity-product'),
        quantity_value = parseInt(quantity_item.text()),
        new_value = quantity_value + 1;
    
    quantity_item.text(new_value);
  }
  
  // EnlÃ¨ve 1 Ã  la quantitÃ© de l'item
  function subQuantity($this) {    
    var quantity_item = $this.siblings('.quantity-product'),
        quantity_value = parseInt(quantity_item.text()),
        new_value = quantity_value - 1;
    
    if(new_value > 0) {
      quantity_item.text(new_value);
    }
  }
  
  // Au clic sur le - de la quantitÃ© 
  function _clickSubQuantityListener($this) {
    subQuantity($this)
  }
  
  // Au clic sur le + de la quantitÃ© 
  function _clickAddQuantityListener($this) {
    addQuantity($this);
  }  
  
  // Au clic sur le - de la quantitÃ©
  $(document).on('click', '.button--sub-product', function(e) {
	_clickSubQuantityListener($(this));
  });
  
  // Au clic sur le + de la quantitÃ© 
  $(document).on('click', '.button--add-product', function(e) {
	_clickAddQuantityListener($(this));
  }); 
  
  /**
   * -------------------------------
   * SECTION - QUESTIONNAIRE
   * -------------------------------
   */
  
  // Met le curseur directement dans le champ texte de la question
  function focusAnswerInputText() {
    var current_open_question = $('.question--open.slick-current');
    
    if(current_open_question.length > 0) {
      var answer_input = current_open_question.eq(0).find('.answer-input');

      answer_input[0].click();
    }
  }
  
  // Change le style d'une rÃ©ponse
  function selectQuestionnaireAnswer($this) {
    var answer = $this.closest('.answer');
    
	answer.siblings().removeClass('selected');
    answer.addClass('selected');
    answer.closest('.answers').find('.answers--errors').addClass('hidden');
  }
  
  // Affiche la question prÃ©cÃ©dente
  function goToPrevQuestion($this) {
	var carousel = $this.closest('.carousel.slick-initialized');
    
    carousel.slick('slickPrev');
  }
  
  // Affiche la question suivante
  function goToNextQuestion($this) {
	var carousel = $this.closest('.carousel.slick-initialized'),
        question = $this.closest('.question'),
        question_completed = false;
    
    if(question.hasClass('question--info')) {
      question_completed = true;
    } else if(question.hasClass('question--multiple')) {
      var selected_answer = question.find('.answer.selected').eq(0);
      
      if(selected_answer.length) {
        question_completed = true;
      }
    } else if(question.hasClass('question--open')) {
      var selected_answer = question.find('.answer').eq(0),
          selected_answer_value = selected_answer.find('.answer-input').val();
      
      if(selected_answer_value != '') {
        question_completed = true;
        selected_answer.addClass('selected');
      }
    }
    
    if(question_completed) {
      carousel.slick('slickNext');
      //focusAnswerInputText();
    } else {
      question.find('.answers--errors').removeClass('hidden');
    }
  }
  
  // Met Ã  jour la barre de progression
  function updateQuestionnaireProgressBar($this, direction) {
    var carousel_wrapper = $this.closest('.carousel-wrapper'),
		carousel = carousel_wrapper.find('.carousel.slick-initialized'),
        current_slide = carousel.find('.slick-current'),
        current_slide_index = parseInt(current_slide.data('slick-index')),
        last_slide_index = parseInt(carousel.find('.question').last().data('slick-index')),
        progress_bar = carousel_wrapper.find('.questionnaire-progress'),
        progress_bar_unit_last = progress_bar.find('.questionnaire-progress-unit.last');
    
    if(current_slide_index > 0 && current_slide_index < last_slide_index) {
      progress_bar.removeClass('hidden');
    } else {
      progress_bar.addClass('hidden');
    }
    
    if(progress_bar_unit_last.length) {
      progress_bar_unit_last.removeClass('last');
    }
    
    if(direction == 'next') {
      var progress_bar_unit_index = current_slide_index - 1,
          progress_bar_unit = progress_bar.find('.questionnaire-progress-unit[data-index="' + progress_bar_unit_index + '"]');
      
      progress_bar_unit.addClass('done');
      progress_bar_unit.addClass('last');
    } else if (direction == 'prev') {
      var progress_bar_unit_index = current_slide_index,
          progress_bar_unit = progress_bar.find('.questionnaire-progress-unit[data-index="' + progress_bar_unit_index + '"]');
      
      progress_bar_unit.removeClass('done');
      progress_bar_unit.prev().addClass('last');
    } else {
    
    }
  }
  
  // Sauvegarde les rÃ©ponses du questionnaire
  function saveQuestionnaire($this) {
    var questionnaire = $this.closest('.questionnaire--carousel'),
        selected_answers = questionnaire.find('.answer.selected'),
        questionnaire_answers_key = '__questionnaire_answers',
        questionnaire_answers_value = {};
    
    selected_answers.each(function(i) {
      var selected_answer = $(this),
          selected_answer_question = selected_answer.closest('.question'),
          selected_answer_question_id = selected_answer_question.data('question-id'),
          selected_answer_question_type = selected_answer_question.data('question-type'),
          selected_answer_value = selected_answer.find('.answer-input').text();
      
      if(selected_answer_question_type == 'open') {
        selected_answer_value = selected_answer.find('.answer-input').val();
      }     
      
      questionnaire_answers_value[selected_answer_question_id] = selected_answer_value;
    });
    
    // On sauvegarde les rÃ©ponses du questionnaire dans le navigateur en local   
    localStorage.removeItem(questionnaire_answers_key);
    localStorage.setItem(questionnaire_answers_key, JSON.stringify(questionnaire_answers_value));
  }
  
  // Au clic sur le bouton d'une rÃ©ponse
  function _clickAnswerButtonListener($this) {
    selectQuestionnaireAnswer($this);
  }
  
  // Au clic sur le bouton "Retour"
  function _clickPrevQuestionListener($this, e) {
    e.preventDefault();
    goToPrevQuestion($this);
    updateQuestionnaireProgressBar($this, 'prev');
  } 
  
  // Au clic sur le bouton "Suivant"
  function _clickNextQuestionListener($this, e) {
    e.preventDefault();
    goToNextQuestion($this);
    updateQuestionnaireProgressBar($this, 'next');
  }
  
  // Au clic sur le bouton "Valider"
  function _clickSaveQuestionnaireListener($this, e) {
    e.preventDefault();
    goToNextQuestion($this);
    updateQuestionnaireProgressBar($this, 'next');
    saveQuestionnaire($this);
  }
  
  // Au clic sur le bouton d'une rÃ©ponse
  $(document).on('click', '.button.answer-input', function(e) {
	_clickAnswerButtonListener($(this));
  });
  
  // Au clic sur le bouton "Retour"
  $(document).on('click', '.button[href="#prev_question"]', function(e) {
	_clickPrevQuestionListener($(this), e);
  }); 
  
  // Au clic sur le bouton "Suivant"
  $(document).on('click', '.button[href="#next_question"]', function(e) {
	_clickNextQuestionListener($(this), e);
  }); 
  
  // Au clic sur le bouton "Valider"
  $(document).on('click', '.button[href="#save_questionnaire"]', function(e) {
	_clickSaveQuestionnaireListener($(this), e);
  });

  /**
   * -------------------------------
   * CART - CHECKBOXES CGV / RÉTRACTATION
   * -------------------------------
   */

  var cartConsentInitialized = false;
  var cartConsentState = {
    accept_cgv: false,
    waive_retraction: false
  };

  var cartConsentAttributeMap = {
    accept_cgv: '__acceptation_cgv',
    waive_retraction: '__renonciation_retractation_ebooks'
  };

  function hasCartConsentCheckboxes() {
    return $('.cart__checkout-checkboxes').length > 0;
  }

  function syncCartConsentCheckboxes() {
    if (!hasCartConsentCheckboxes()) {
      return;
    }

    $('[data-cart-consent]').each(function() {
      var key = $(this).attr('data-cart-consent');
      this.checked = !!cartConsentState[key];
    });
  }

  function updateCartSubmitButtons() {
    if (!hasCartConsentCheckboxes()) {
      return;
    }

    var bothChecked = cartConsentState.accept_cgv && cartConsentState.waive_retraction;
    $('.button--submit-cart').prop('disabled', !bothChecked);
  }

  function saveCartConsentAttributes() {
    if (!hasCartConsentCheckboxes()) {
      return;
    }

    var attributes = {};

    attributes[cartConsentAttributeMap.accept_cgv] = cartConsentState.accept_cgv ? 'oui' : '';
    attributes[cartConsentAttributeMap.waive_retraction] = cartConsentState.waive_retraction ? 'oui' : '';

    $.ajax({
      type: 'POST',
      url: (window.theme.localeRootUrl || '') + '/cart/update.js',
      dataType: 'json',
      data: { attributes: attributes }
    });
  }

  function applyCartConsentUi() {
    if (!hasCartConsentCheckboxes()) {
      return;
    }

    syncCartConsentCheckboxes();
    updateCartSubmitButtons();
  }

  function bindCartConsentListeners() {
    if (cartConsentInitialized) {
      return;
    }

    cartConsentInitialized = true;

    $(document).on('change.cartConsent', '[data-cart-consent]', function() {
      if (!hasCartConsentCheckboxes()) {
        return;
      }

      var key = $(this).attr('data-cart-consent');
      cartConsentState[key] = this.checked;
      applyCartConsentUi();
      saveCartConsentAttributes();
    });

    $(document).on('click.cartConsent', '[data-action="open-cart-policy"]', function(e) {
      e.preventDefault();

      if (!hasCartConsentCheckboxes()) {
        return;
      }

      var modalSelector = $(this).attr('data-modal');
      var $modal = $(modalSelector);

      if ($modal.length === 0) {
        return;
      }

      var instance = $modal.remodal({ hashTracking: false });
      instance.open();
    });

    $(document).on('submit.cartConsent', '.cart__form', function(e) {
      if (!hasCartConsentCheckboxes()) {
        return;
      }

      if (!cartConsentState.accept_cgv || !cartConsentState.waive_retraction) {
        e.preventDefault();
        updateCartSubmitButtons();
      }
    });
  }

  function initCartConsent() {
    if (!hasCartConsentCheckboxes()) {
      return;
    }

    bindCartConsentListeners();
    applyCartConsentUi();
  }

  initCartConsent();

  // Si le mini-panier charge les cases après coup, initialiser / resynchroniser
  $(document).ajaxComplete(function(event, xhr, settings) {
    if (settings.url && settings.url.indexOf('mini-cart-content') !== -1) {
      initCartConsent();
    }
  });
  
}(jQuery));
